import { ActionMap } from 'action-typed';
import { ResolvedUrl } from '@wearejh/m2-pwa-engine/lib/utils/resolve';

import { StoreState } from 'src/types/global-types';

export type NavigationCompleteData = {
    componentName?: ResolvedUrl['componentName'];
    id?: ResolvedUrl['id'];
    pathname: StoreState['router']['location']['pathname'];
};

export enum NavigationEvents {
    NAVIGATION_COMPLETE = 'Navigation.Complete',
}

export type Messages = {
    [NavigationEvents.NAVIGATION_COMPLETE]: NavigationCompleteData;
};

export type TypeMap = ActionMap<Messages>;
export type NavigationActions = TypeMap[keyof TypeMap];

export function isNavigationAction(action: any): action is NavigationActions {
    return Object.values(NavigationEvents).includes(action.type);
}
